<h3>Generate Payroll Monthly Report</h3>
<div>
	<rpshared-date-picker
		[formControl]="startDate"
		placeholder="Start Date"
		hint="Runs from start date to end of selected month"
		required
	></rpshared-date-picker>
	<mat-form-field class="filename">
		<input
			matInput
			[formControl]="filename"
			placeholder="Filename"
			autocomplete="off"
			required
		/>
		<mat-icon matSuffix>description</mat-icon>
	</mat-form-field>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
	<button mat-button type="button" color="primary" mat-dialog-close>
		Cancel
	</button>
	<button
		mat-button
		type="button"
		color="primary"
		[disabled]="!isValid.value"
		[mat-dialog-close]="payrollMonthlyReportArgs.value"
	>
		OK
	</button>
</div>
